module.exports = __webpack_public_path__ + "static/img/back-last-section.2b934d7.jpg";